import { render } from "./IconSattelite.vue?vue&type=template&id=31d45a38"
import script from "./IconSattelite.vue?vue&type=script&lang=js"
export * from "./IconSattelite.vue?vue&type=script&lang=js"
script.render = render

export default script